import { AuditLogItem } from '../../domain/audit.log.item';
import { TransferLogItem } from '../../domain/license.transfer.log';
import { SortItem, sortTypes, sortDirection } from './member.dashboard.license.response';

export enum TOSActivityTypes {
    Transfer = 0,
    Audit = 1
}

export class TOSActivityLogResponse {
    ActivityType: TOSActivityTypes;
    AuditLog: AuditLogItem;
    TransferLog: TransferLogItem;

    public static FixDates(item: TOSActivityLogResponse) {

        if (item.AuditLog != undefined)
            AuditLogItem.FixDate(item.AuditLog);

        if (item.TransferLog != undefined)
            TransferLogItem.FixDates(item.TransferLog);

    }

}

export class TOSActivityLogResponseArray extends Array<TOSActivityLogResponse> {

    public LastSort = new SortItem;

    constructor(...items: TOSActivityLogResponse[]) {
        super(...items);
        Object.setPrototypeOf(this, TOSActivityLogResponseArray.prototype);
    }

    public static FixDates(items: TOSActivityLogResponseArray) {
        items.forEach(x => TOSActivityLogResponse.FixDates(x));
    }

    public static checkVariables(checkThis: TOSActivityLogResponseArray) {
        if (checkThis.LastSort == undefined) {
            checkThis.LastSort = new SortItem;
            checkThis.LastSort.SortType = sortTypes.ID;
            checkThis.LastSort.SortDirection = sortDirection.Unsorted;
        }
    }

    public static sortByDate(sortThis: TOSActivityLogResponseArray, direction: sortDirection = sortDirection.NotSpecified): TOSActivityLogResponseArray {
        this.checkVariables(sortThis);
        if ( (sortThis.LastSort.SortType == sortTypes.CreationDate && direction == sortDirection.NotSpecified && sortThis.LastSort.SortDirection == sortDirection.Ascending) || direction == sortDirection.Descending ) {
            sortThis.sort( (a, b) => {
                let dateA = new Date().getTime();
                let dateB = new Date().getTime();

                if ( a.AuditLog != undefined && a.AuditLog != null && b.AuditLog != undefined && b.AuditLog != null ) {
                    if (a.AuditLog.DateTimeCreated && b.AuditLog.DateTimeCreated ) {
                        if ( a.AuditLog.DateTimeCreated != undefined )
                            dateA = a.AuditLog.DateTimeCreated.getTime();
                        if ( b.AuditLog.DateTimeCreated != undefined )
                            dateB = b.AuditLog.DateTimeCreated.getTime();
                    }

                }else if ( a.TransferLog != undefined && a.TransferLog != null &&  b.TransferLog != undefined && b.TransferLog != null) {
                    if (a.TransferLog.DateTimeCreated && b.TransferLog.DateTimeCreated) {
                        if ( a.TransferLog.DateTimeCreated != undefined )
                            dateA = a.TransferLog.DateTimeCreated.getTime();
                        if ( b.TransferLog.DateTimeCreated != undefined )
                            dateB = b.TransferLog.DateTimeCreated.getTime();
                    }

                }

                return dateB - dateA;
            });
            sortThis.LastSort.SortDirection = sortDirection.Descending;
        } else {
            sortThis.sort( (a, b) => {
                let dateA = new Date().getTime();
                let dateB = new Date().getTime();

                if ( a.AuditLog != undefined && a.AuditLog != null && b.AuditLog != undefined && b.AuditLog != null ) {
                    if (a.AuditLog.DateTimeCreated && b.AuditLog.DateTimeCreated ) {
                        if ( a.AuditLog.DateTimeCreated != undefined )
                            dateA = a.AuditLog.DateTimeCreated.getTime();
                        if ( b.AuditLog.DateTimeCreated != undefined )
                            dateB = b.AuditLog.DateTimeCreated.getTime();
                    }

                }else if ( a.TransferLog != undefined && a.TransferLog != null &&  b.TransferLog != undefined && b.TransferLog != null) {
                    if (a.TransferLog.DateTimeCreated && b.TransferLog.DateTimeCreated) {
                        if ( a.TransferLog.DateTimeCreated != undefined )
                            dateA = a.TransferLog.DateTimeCreated.getTime();
                        if ( b.TransferLog.DateTimeCreated != undefined )
                            dateB = b.TransferLog.DateTimeCreated.getTime();
                    }

                }

                return dateA - dateB;
            });
            sortThis.LastSort.SortDirection = sortDirection.Ascending;
        }
        sortThis.LastSort.SortType = sortTypes.CreationDate;
        return sortThis;
    }


}

